import { render, staticRenderFns } from "./MessagesContainer.vue?vue&type=template&id=47ac8934&scoped=true"
import script from "./MessagesContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesContainer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MessagesContainer.vue?vue&type=style&index=0&id=47ac8934&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac8934",
  null
  
)

export default component.exports